import { render, staticRenderFns } from "./classOpenServiceOne.vue?vue&type=template&id=27453903&scoped=true&"
import script from "./classOpenServiceOne.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceOne.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceOne.vue?vue&type=style&index=0&id=27453903&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27453903",
  null
  
)

export default component.exports